import "@babel/polyfill"
import "whatwg-fetch"
import "react_ujs"
import { SelfHydratingHeader } from "@planningcenter/cc-nav"

import Components from "components"
const { ChurchCenter, Shared } = Components
import Sprinkles from "sprinkles"
const { ChurchCenter: ChurchCenterSprinkles, Shared: SharedSprinkles } = Sprinkles

import jQuery from "jquery"
import * as React from "react"
import ReactDOM from "react-dom"
import moment from "moment-timezone"
import QRCode from "qrcode"
import Turbolinks from "turbolinks"

Object.assign(window, {
  $: jQuery,
  Components: Object.assign(ChurchCenter, Shared, { SelfHydratingHeader }),
  Sprinkles: Object.assign(ChurchCenterSprinkles, SharedSprinkles),
  React,
  ReactDOM,
  QRCode,
  Turbolinks
})

if (window.App?.currentOrganization?.timezone) {
  moment.tz.setDefault(App.currentOrganization.timezone)
}

document.addEventListener("DOMContentLoaded", () => ChurchCenterSprinkles.initialize())

Turbolinks.start()
